export const SET_STAGES = "SET_STAGES"
export const SET_FIRST = "SET_FIRST"
export const SET_SECONDS = "SET_SECONDS"
export const SET_BLOB = "SET_BLOB"
export const SET_PROFILE = "SET_PROFILE"
export const RESTORE_STORE = "RESTORE_STORE"
export const SET_REDIRECT = "SET_REDIRECT"
export const SET_QUERY_PARAMS = "SET_QUERY_PARAMS"